var ChangePasswordModule = /** @class */ (function () {
    function ChangePasswordModule() {
    }
    return ChangePasswordModule;
}());
export { ChangePasswordModule };
